import locales from './locales';
import contentTypes from './content-types';
import isoLocales from './iso-locales';

export default {
  locales,
  'iso-locales': isoLocales,
  'content-types': contentTypes,
};
